import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';

import { ApiServiceServerless } from '../../xhr_libs';
import AddEntityActionButtons from '../forms/AddEntityActionButtons';

export default function AddBuildingGroupModal(props) {
  const {
    show,
    onHide,
    organization_id,
    building_ids,
    showToast,
    setActiveGroup,
    setActiveGroupId,
    setOrganization,
  } = props;

  const [groupName, setGroupName] = useState('');

  const [isLoading, setIsLoading] = useState(false);



  const addGroup = (e) => {
    e.preventDefault();
    setIsLoading(true);
    ApiServiceServerless.post(
      `/organizations/${organization_id}/groups`,
      {
        organization_id: organization_id,
        name: groupName,
        building_ids: building_ids
      },
      { authorization_id: organization_id }
    )
      .then((res) => {
        setOrganization((prev) => ({
          ...prev,
          building_groups: [...prev.building_groups, res.data],
        }));
        setActiveGroup(null);
        setActiveGroupId(res.data.id);
        showToast('success', 'Success', `New Group was Added.`);
      })
      .catch(() => {
        showToast('danger', 'Alert', 'Group Creation Error');
      })
      .finally(() => {
        onHide();
        setIsLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>Add Group</Modal.Header>
      <Form onSubmit={addGroup}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              {'Group Name'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setGroupName(e.target.value)}
              />
            </Form.Row>
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <AddEntityActionButtons
            onCancel={onHide}
            submitDisabled={groupName === ''}
            isSubmitting={isLoading}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
